import {
    AvailableHoursResponse,
    FreeSlotsRequestBody,
} from "modules/BookingCommon/common/interfaces"
import { httpClient } from "utils/infrastructure/httpClient"

export function getAvailableHours<T>(data: FreeSlotsRequestBody, additionalData: T) {
    return httpClient.post<AvailableHoursResponse>("psychologist/events/available-hours", {
        ...data,
        ...additionalData,
    })
}
